module.exports = __webpack_public_path__ + "static/media/29COICT4.a7c53279.jpg";